import React, {useContext, useState, useEffect }from 'react'
import { AppContext } from "../../App.js";
import { NavLink, Link } from 'react-router-dom';


import './googleAdsCompt.css';
import './portadaGoogleAds.css';
import './sectionAS-EM.css';


//Import Assets
import IconGoogleAnalytics from '../../assets/IconWebGoogle/IconWebGoogle-Analytics.svg';
import IconGoogleAds from '../../assets/IconWebGoogle/IconWebGoogle-Ads.svg';
import IconGoogleMaps from '../../assets/IconWebGoogle/IconWebGoogle-Maps.svg';
import IconGoogleYoutube from '../../assets/IconWebGoogle/IconWebGoogle-YouTube.svg';
import LogoWebmedia from '../../assets/homeAssets/logoWebMedia.svg';
import IconLupa from '../../assets/googleAdsAssets/IconLupa.svg';
import photoAS from '../../assets/googleAdsAssets/bkPhotos-AS-EM/photo-AS.jpg';
import photoEM from '../../assets/googleAdsAssets/bkPhotos-AS-EM/photo-EM.jpg';
import photoPAJ from '../../assets/googleAdsAssets/bkPhotos-AS-EM/photo-banner-Paj.jpg';


//Import Components
import { PhotoPlanningComponent } from './photoPlanningCompoent';
import { FooterComponent } from '../footerComponent/footerComponent'
import { BarraMenuDown } from '../home/barraMenuDown';
import { PanelMenuSlideDV } from '../developComponent/panelMenuSlideDV';


//Import Assets
import IconAsesoramiento from '../../assets/googleAdsAssets/IconPlanningADS/IconPlannig-Asesoramiento.svg'
import IconPublicoObjetivo from '../../assets/googleAdsAssets/IconPlanningADS/IconPlannig-PublicoObjetivo.svg'
import IconAnuncioPresupuesto from '../../assets/googleAdsAssets/IconPlanningADS/IconPlannig-AnunciosPresupuesto.svg'
import IconAnalisisDatos from '../../assets/googleAdsAssets/IconPlanningADS/IconPlannig-AnalisisDatos.svg'
import bkBlockA from '../../assets/googleAdsAssets/bkPhotosPlanning/Bk-Block-A.jpg'
import bkBlockB from '../../assets/googleAdsAssets/bkPhotosPlanning/Bk-Block-B.jpg'
import bkBlockC from '../../assets/googleAdsAssets/bkPhotosPlanning/Bk-Block-C.jpg'
import bkBlockD from '../../assets/googleAdsAssets/bkPhotosPlanning/Bk-Block-D.jpg'



export function GoogleAdsCompt() {


    const {

    //Panel Menu Slide Dv
      openMenuSlideDv,
      setOpenMenuSlideDv,
      valorScreenDv,
      setValorScreenDv

    } = useContext(AppContext);


    return(

        <div className='container-all-google-ads' translate="no">


            <BarraMenuDown />
            
            <PanelMenuSlideDV 
            
                activeMenu='google-ads'
            />

            {/* SECCION PORTADA GOOGLE ADS */}
            <div className='container-bk-portada-google-ads'>

                <div className='box-btn-slide-menu-logo'>

                    <button className='btn-slide-menu-google-ads'  onClick={() => setOpenMenuSlideDv(!openMenuSlideDv)}> 
                        
                        <span id='btn-slide-menu-google-ads' className="material-symbols-outlined">menu</span>

                    </button>

                    <img className='logo-webmedia-google-ads' src={LogoWebmedia} alt='Logo Webmedia'/>

                </div>

                <div className='box-content-info-portada'>

                    <div className='box-seach-info'>
                        <img className='icon-lupa' src={IconLupa} alt='busqueda Webmail'/>
                        <p className='text-buscador'>Su marca primera en búsquedas</p>
                    </div>

                    <div className='box-icons-google'>
                        <img className='iconGoogle icon-analytics' src={IconGoogleAnalytics}></img>
                        <img className='iconGoogle icon-ads' src={IconGoogleAds}></img>
                        <img className='iconGoogle icon-maps' src={IconGoogleMaps}></img>
                        <img className='iconGoogle icon-youtube' src={IconGoogleYoutube}></img>
                    </div>

                    <div className='box-text-portada-google-ads'> 
                        <p>Creamos campañas de anuncios estratégicos y eficientes</p> 
                    </div>

                </div>


            </div>

            {/* SECTION PLANNING GOOGLE ADS */}
            <div className='container-planning-google-ads'>

                <div className='box-title-text-planning'>

                    <p className='title-text-planning'> 
                        Asesoramos y planificamos campaña dentro del entorno de anuncios 
                        de Google Ads con visión estratégica y objetivos específicos
                    </p>

                </div>

                <div className='box-gallery-plannig'>

                    <div className='box-block-planning box-block-A'>
                        
                        {/* Photo - A */}
                        <PhotoPlanningComponent 

                            bkPhotoPlannig={bkBlockA}
                            iconPlanning={IconAsesoramiento}
                            titlePlanning='Asesoramiento y planeación de campaña'
                            textCortinaPlanning='
                            En conjunto con el cliente planificamos cada aspecto de la campaña a fin de
                            establecer los lineamientos y objetivos propuestos, optimizando el presupuesto
                            y maximizando el rendimiento de sus anuncios.'

                        />
                        

                        {/* Photo - B */}
                        <PhotoPlanningComponent 

                            bkPhotoPlannig={bkBlockB}
                            iconPlanning={IconAnuncioPresupuesto}
                            titlePlanning='Direccionamiento y segmentación del público objetivo'
                            textCortinaPlanning='Con visión estratégica direccionamos su campaña hacia el público 
                            objetivo correcto, segmentando el perfil de usuario y su geolocalización con base en 
                            sus productos, cobertura y servicios.'
                        />

                    </div>

                    <div className='box-block-planning box-block-B'>  

                        {/* Photo - C */}
                        <PhotoPlanningComponent 

                            bkPhotoPlannig={bkBlockC}
                            iconPlanning={IconAnalisisDatos}
                            titlePlanning='Programación de anuncios y ejecución del presupuesto'
                            textCortinaPlanning='Conforme a lo planificado se programa el o los anuncios en tiempo y
                             espacio ejecutando estratégicamente el presupuesto de acuerdo a los objetivos plateados 
                             y a la duración de la campaña.'

                        />
                        

                        {/* Photo - D */}
                        <PhotoPlanningComponent 

                            bkPhotoPlannig={bkBlockD}
                            iconPlanning={IconPublicoObjetivo}
                            titlePlanning='Seguimiento y optimización de campaña'
                            textCortinaPlanning='Realizamos un seguimiento progresivo analizando los datos de rendimiento 
                            de los anuncios a fin de optimizar la estrategia, mejorar los puntos relevantes y realizar 
                            los ajustes necesarios.'
                        />

                    </div>

                </div>

            </div>

            {/* SECTION ANALISIS Y SEGUIMIENTO */}
            <div className='container-section-AS-EM'>

                {/* Bloque Analisis y Seguimiento */}
                <div className='Box-Block-AS'>

                    <div className='box-info-AS'>

                        <h2 className='title-Analisis-AS'>ANÁLISIS DE DATOS</h2>
                        <p className='text-info-Analisis-AS'>

                            Recopilamos y analizamos los datos obtenidos en el periodo de activación de los anuncios. 
                            Generemos un informe de resultados con un análisis completo sobre el perfil demográfico del usuario, 
                            su localización, la taza de conversión, el rendimiento de la inversión, entre otros.

                        </p>

                    </div>

                    <div className='box-photo-AS'>

                        <img className='photo-AS' src={photoAS}/>

                    </div>

                </div>

                {/* Bloque Entrega Metricas */}
                <div className='Box-Block-EM'>

                    <div className='box-photo-EM'>

                        <img className='photo-EM' src={photoEM}/>

                    </div>

                    <div className='box-info-EM'>

                        <h2 className='title-Analisis-EM'>ENTREGA DE RESULTADOS</h2>
                        <p className='text-info-Analisis-EM'>

                                Al finalizar la campaña de anuncios entregamos un informe global con todas 
                                las métricas y resultados obtenidos durante el periodo de activación de cada 
                                anuncio. 
                                El informe incluye datos de rendimiento con índices estadísticos comparativos 
                                de campaña anteriores. 


                        </p>

                    </div>

                </div>

            </div>


            {/* SECTION COMENTARIO PLANIFICAMOS AJUSTAMOS */}
            <div className='container-section-PAJ'>

                <div className='box-text-photo-PAJ'>

                    <p className='text-PAJ'> 

                        planificamos y ajustamos su campaña de 
                        anuncios de acuerdo a su presupuesto,
                        alcance, productos y servicios.

                    </p>

                    {/* Ba¿ackgroun Imagen Photo Banner */}
                    <div className='box-photo-banner-PAJ'></div>


                </div>

            </div>


            {/* SECTION FOOTER COMPONENT */}
            <FooterComponent /> 
            



        </div>

    );


}